import * as React from 'react';
import { useState } from 'react';
import EmailModal from '../../../components/bookings/modals/EmailModal';
import EditModal from '../../../components/bookings/update/modal/EditModal';
import ErrorModal from '../../../components/common/ErrorModal';
import LoadingModal from '../../../components/common/LoadingModal';
import { Booking } from '../../../models/bookings/Booking';
import { BookingType } from '../../../models/bookings/BookingType';
import { EditBooking } from '../../../models/bookings/EditBooking';
import { apiPut } from '../../../services/api';

interface EditModalContainerProps {
    booking: Booking;
    showModal: boolean;
    onEditConfirmed?(): void;
    onEmailSent(): void;
    onClose(): void;
}

const EditModalContainer: React.FC<EditModalContainerProps> = ({
    booking,
    showModal,
    onEditConfirmed,
    onEmailSent,
    onClose
}) => {
    const [edited, setEdited] = useState(false);
    const [editing, setEditing] = useState(false);
    const [error, setError] = useState<unknown>(false);

    const handleCloseRequested = () => {
        if (editing) {
            return;
        }
        onClose();
    };

    const handleEditConfirmed = async (editedBooking: EditBooking) => {
        setEditing(true);
        try {
            await apiPut(`Booking/${booking.id}`, editedBooking);
            setEditing(false);
            onEditConfirmed && onEditConfirmed();
            if (
                booking.bookingType === BookingType.Resource ||
                booking.bookingType === BookingType.Internal ||
                booking.bookingType === BookingType.NoBookings
            ) {
                onClose();
            }
            setEdited(true);
        } catch (e) {
            console.warn(e);
            setError(e);
            setEditing(false);
        }
    };

    const showEditModal = !edited && !editing && !error;

    return (
        <>
            <EditModal
                booking={booking}
                showModal={showModal && showEditModal}
                onEditConfirmed={handleEditConfirmed}
                onClose={onClose}
            />
            <LoadingModal
                showModal={showModal && editing}
                header={`Edit Booking ${booking.reference}`}
                loadingText="editing"
            />
            <EmailModal
                booking={booking}
                showModal={showModal && edited}
                emailType="edited"
                bookingType={'booking'}
                onEmailSent={onEmailSent}
                onClose={handleCloseRequested}
            />
            <ErrorModal
                showModal={showModal && !!error}
                header={`Edit Booking ${booking.reference}`}
                errorText="There was an error editing the booking."
                onClose={onClose}
            />
        </>
    );
};

export default EditModalContainer;
